module.exports = __webpack_public_path__ + "images/saaremaa/top-strip.png";